// extracted by mini-css-extract-plugin
module.exports = {"close-button":"_3FoQF","closeButton":"_3FoQF"};